import OrdersSection from "../ProductionPage/sections/OrdersSection/OrdersSection";
import PageWrapper from "../PageWrapper/PageWrapper";

function ProductionOrdersPage() {

  return (
    <PageWrapper>
      <>
        <OrdersSection />
      </>
    </PageWrapper>
  );
}

export default ProductionOrdersPage;

